<template>
  <div>
    <header-bar>登録情報</header-bar>
    <div class="page-block">
      <div class="page-block__heading page-block__heading--withbar">
        <h3 class="page-block__title">アカウント情報 - メールアドレス編集</h3>
      </div>
      <div class="page-block__inner">
        <div
          v-if="completed"
          class="profile-info">
          <div class="form-complete-area">
            <div class="form-complete-area__title">
              メールアドレスの変更を受け付けました
            </div>
            <br />
            ご登録頂いた新しいメールアドレスに、<br />
            確認のメールを送らせて頂きましたので、<br />
            メール内のリンクより変更作業を完了させてください。
          </div>
          <div class="c-btn-wrap">
            <router-link
              :to="{ name: 'profile' }"
              class="c-btn c-btn--back">
              戻る
              <span class="c-btn__icon-arrow c-btn__icon-arrow--left"></span>
            </router-link>
          </div>
        </div>
        <div
          v-else
          class="profile-info">
          <form
            :class="{ 'form--error': errors }"
            @submit.prevent="onSaveClicked">
            <div class="form-wrap form-wrap--profile u-no-margin-top">
              <div class="form-group">
                <div class="form-label">
                  <label class="control-label">現在のメールアドレス（ID）</label>
                </div>
                <div class="form-item">{{ current_email }}</div>
              </div>
              <div class="form-group">
                <div class="form-label">
                  <label
                    class="control-label"
                    for="new_mail">新しいメールアドレス（ID）
                  </label>
                </div>
                <div class="form-item">
                  <input
                    id="new_mail"
                    v-model="email"
                    class="form-control"
                    type="text"
                    :placeholder="`${isBtoC?'new-email@narasu.jp':'new-email@zula.jp'}`">
                  <p
                    v-if="errors['email']"
                    class="error-text">
                    {{ errors['email'][0] }}
                  </p>
                </div>
              </div>
              <div class="form-group">
                <div class="form-label">
                  <label
                    class="control-label"
                    for="email_confirmation">新しいメールアドレス（確認）
                  </label>
                </div>
                <div class="form-item">
                  <input
                    id="email_confirmation"
                    v-model="email_confirmation"
                    class="form-control"
                    type="text"
                    :placeholder="`${isBtoC?'new-email@narasu.jp':'new-email@zula.jp'}`">
                  <p
                    v-if="errors['email_confirmation']"
                    class="error-text">
                    {{ errors['email_confirmation'][0] }}
                  </p>
                </div>
              </div>
            </div>
            <div class="c-btn-wrap">
              <a
                class="c-btn"
                @click.prevent="onSaveClicked">
                内容を保存
                <span class="c-btn__icon-arrow"></span>
              </a>
              <router-link
                :to="{ name: 'profile' }"
                class="c-btn c-btn--back c-btn--back-left">
                戻る
                <span class="c-btn__icon-arrow c-btn__icon-arrow--left"></span>
              </router-link>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderBar from '../HeaderBar'

export default {
  name: 'ProfileEditMail',
  components: { HeaderBar },
  data() {
    return {
      current_email: '',
      email: '',
      email_confirmation: '',
      completed: false,
      errors: {
        email: [],
      },
    }
  },
  mounted() {
    this.fetchItem()
  },
  methods: {
    async fetchItem() {
      const response = await window.axios.get(`/api/client/users/${this.$store.state.auth.id}`)
      this.current_email = response.data.email
    },
    async onSaveClicked() {
      window.scrollTo(0, 0)
      try {
        const params = { email: this.email, email_confirmation: this.email_confirmation }
        await window.axios.put('/api/client/user/change-email', params)
        this.completed = true
      } catch ({ response }) {
        const { errors } = response.data
        this.errors = errors
      }
    },
  },
}
</script>

<style scoped>

</style>
